var configs = {
    insertMethod: 'append',
    insertSelector: 'body'
};
export default configs;



//////////////////
// WEBPACK FOOTER
// ../~/mmenu-js/dist/addons/fixedelements/_configs.js
// module id = 63
// module chunks = 0